const callCenterList = {
    get: 'userCallRequest/get',
    add: 'CallHistory/add',
    sendCopon: 'CouponUser/saleOff'
}
export default callCenterList